"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuestionSetDelete = void 0;
const QuestionSetModel_1 = __importDefault(require("@opsbase/lib-data-model/models/QuestionSetModel"));
const GQLMutationHook_1 = __importDefault(require("@opsbase/react-gql/GQLMutationHook"));
const GQLType_1 = __importDefault(require("@opsbase/react-gql/GQLType"));
const QuestionSetDeleteConfig = {
    type: GQLType_1.default.MUTATION,
    model: QuestionSetModel_1.default,
    name: 'deleteQuestionSet',
    params: { id: 'String!' },
    fields: 'NONE',
    refetchQueries: ['questionsets', 'QUESTIONSETS'],
};
exports.useQuestionSetDelete = (0, GQLMutationHook_1.default)(QuestionSetDeleteConfig);
exports.default = exports.useQuestionSetDelete;
